import { factoryService, getFileRequest, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL, REACT_APP_API_GESINTEL_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * To get the access token Gesintel
 */
export const getAccessTokenGesintel = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/gestordocumental/sancion/token`)
})

/**
 * To upload an attachment file that could be related to some sanction.
 */
export const uploadFile = factoryService(
  ({ base64File, entCode, fileName, id, orgLegalName, sellerType, token, type = 'SANC' }) => {
    const body = {
      type,
      code: entCode,
      name: fileName,
      rut: id,
      providerType: sellerType,
      providerName: orgLegalName,
      content: base64File
    }
    console.log(body)
    return postJsonRequest(`${REACT_APP_API_GESINTEL_BASE_URL}/app/rest/sendDocument`, { body, token })
  }
)

/**
 * To download an attachment file.
 */
export const downloadSanctionFile = factoryService(({ docFolio }) => {
  return getFileRequest(`${REACT_APP_API_BASE_URL}/v1/gestordocumental/sancion/obtenerarchivo/${docFolio}`)
})

/**
 * To download a legal document attachment file.
 */
export const downloadLegalDocumentFile = factoryService(({ code }) => {
  return getFileRequest(`${REACT_APP_API_BASE_URL}/v1/gestiondoc/getFileDocument/${code}`)
})

/*
 * Gets the seller legal documents data.
 */
export const getSellerLegalDocuments = factoryService(({ dni }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/gestiondoc/documentacion-legal${dni !== undefined ? `/${normalizeDniSlashes(dni)}` : ''}`
  )
)
